import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../../../components/style-class'
import { createMediaQuery } from '../../../components/style-class/style-class.utils'

/* Types ======================================================================================== */
type ClassNames = {
  base: string
  baseInner: string
  borderBottom: string
  baseTable: string
}

type ClassProps = any

const getNames: (props: any, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    width: 440,
    // height: '100%',
    $nest: {
      ...createMediaQuery.md({
        width: '100%',
      }),
    },
  })

  const baseInner = style({
    width: '100%',
    overflow: 'auto',
    minHeight: 254,
    height: '100%',
  })

  const borderBottom = style({
    borderBottom: `1px solid ${theme.boxes.border.medium}`,
  })

  const baseTable = style({
    borderCollapse: 'collapse',
  })

  return {
    base,
    baseInner,
    borderBottom,
    baseTable,
  }
}

/* Export ======================================================================================= */
export const portalClass = new StyleClass<ClassNames, ClassProps>(getNames)
